import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Title from "../common/Title";
import { FaShieldAlt } from "react-icons/fa";
import PermissionGroupsTab from "./PermissionGroupsTab";
import UserPermissionsLookup from "./UserPermissionsLookup";
import RunbookAccessLookup from "./RunbookAccessLookup";
import Joyride, { STATUS } from "react-joyride";
import { useTour } from "../../contexts/TourContext";

function PermissionsManager(props) {
  const { activeTour, endTour } = useTour();
  const [runTour, setRunTour] = useState(false);
  const [activeTab, setActiveTab] = useState("groups");

  useEffect(() => {
    if (activeTour === "permissions") {
      setRunTour(true);
    }
  }, [activeTour]);

  const tourSteps = [
    {
      target: "body",
      content: "Welcome to Permissions Management! Let me show you how to control access to your runbooks.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="permissions-title"]',
      content: "This is the Permissions Management page where you can create permission groups and assign permissions to users.",
    },
    {
      target: '[data-tour="add-group-btn"]',
      content: "Click here to create a new permission group. Groups let you organize users and assign runbook access.",
    },
    {
      target: '[data-tour="permissions-grid"]',
      content: "Here you'll see all your permission groups. Each group can have different users and runbook permissions.",
    },
    {
      target: '[data-tour="group-actions"]',
      content: "Use these buttons to edit group members, assign runbook permissions, or delete the group.",
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false);
      endTour("permissions");
    }
  };

  return (
    <>
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showProgress
        showSkipButton
        callback={handleJoyrideCallback}
        styles={{
          options: {
            primaryColor: "#cf7f00",
            textColor: "#334155",
            backgroundColor: "#ffffff",
            arrowColor: "#ffffff",
            zIndex: 10000,
          },
          buttonNext: {
            backgroundColor: "#cf7f00",
            borderRadius: "0.5rem",
            fontSize: "14px",
            padding: "10px 20px",
          },
          buttonBack: {
            color: "#cf7f00",
            marginRight: "10px",
          },
          buttonSkip: {
            color: "#64748b",
          },
          tooltip: {
            borderRadius: "0.75rem",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          },
          tooltipContent: {
            padding: "20px",
          },
        }}
      />
      {!props.hideTitle && (
        <Title
          text="Permissions Management"
          icon={<FaShieldAlt className="mb-1" />}
          data-tour="permissions-title"
        />
      )}

      <div className={props.hideTitle ? "permissions-tabs-fill" : undefined}>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
      >
        <Tab eventKey="groups" title="Permission Groups">
          <PermissionGroupsTab user={props.user} hideTitle={props.hideTitle} />
        </Tab>
        <Tab eventKey="user-permissions" title="User Permissions Lookup">
          <UserPermissionsLookup user={props.user} />
        </Tab>
        <Tab eventKey="runbook-access" title="Runbook Access Lookup">
          <RunbookAccessLookup user={props.user} />
        </Tab>
      </Tabs>
      </div>
    </>
  );
}

export default PermissionsManager;
